<template>
    <v-navigation-drawer
        @input="getthe"
        v-model="local_drawer"
        :mini-variant="mini"
        app
    >
        <div class="background-nav"></div>

        <v-list-item @click.stop="mini = !mini" class="avatar-b-color">
            <v-list-item-content>
                <v-list-item-title class="text-center">
                    <!-- Logo comentado temporalmente hasta tener el de Electrotecnia Inelco -->
                    <!-- <img
                        style="width: 75%; margin: auto; border-radius: 15px"
                        :src="rol != 13 ? 'logo.png' : 'logo_show.jpg'"
                    /> -->
                    <h4>ELECTROTECNIA INELCO</h4>
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <default-lateral></default-lateral>
        <div style="padding: 1rem" v-if="main_rol == 14">
            <v-autocomplete
                v-model="id_usuario"
                :items="usuarios"
                item-text="name"
                item-value="id"
                label="Usuario"
            >
            </v-autocomplete>
        </div>
    </v-navigation-drawer>
</template>

<script>
import defaultLateral from "./defaultLateral.vue";
export default {
    props: ["drawer"],
    components: {
        defaultLateral,
    },
    created() {
        this.getUsuarios();
    },
    methods: {
        getUsuarios() {
            axios.get(`api/get-usuarios`).then(
                (res) => {
                    this.usuarios = res.data.users;
                },
                (err) => {
                    this.$toast.error("Error consultando los usuarios");
                }
            );
        },
        getthe(e) {
            this.$emit("emitInnputDrawer", e);
        },
    },
    data() {
        return {
            lateral: "defaultLateral",
            mini: false,
            local_drawer: true,
            id_usuario: parseInt(localStorage.getItem("user_id")),
            main_rol: parseInt(localStorage.getItem("real_role")),
            usuarios: [],
        };
    },
    watch: {
        drawer: {
            immediate: true,
            handler: function (n) {
                this.local_drawer = n;
            },
        },
        id_usuario(val) {
            const usuario = this.usuarios.find((element) => element.id == val);
            console.log(usuario);
            localStorage.setItem("role", usuario.idRol);
            localStorage.setItem("user_id", usuario.id);

            window.location.reload();
        },
    },
    computed: {
        rol() {
            return localStorage.getItem("role");
        },
        auth() {
            //return this.$store.getters.getauth
            return "a";
        },
        user() {
            return "u";
            //  return this.$store.getters.getuser
        },
    },
};
</script>

<style media="screen">
.v-navigation-drawer .v-list .v-list-item > .v-list__tile .v-list__tile__title {
    font-size: 14px !important;
    font-weight: 100;
    padding: 0;
}

.v-list--dense .v-list-item .v-list-item__subtitle,
.v-list--dense .v-list-item .v-list-item__title,
.v-list-item--dense .v-list-item__subtitle,
.v-list-item--dense .v-list-item__title {
    font-size: 17px !important;
    font-weight: 700 !important;
}

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
    margin-right: 15px;
}

.v-list--dense .v-list-item .v-list-item__icon,
.v-list-item--dense .v-list-item__icon {
    opacity: 0.9;
    color: #fff;
}

.v-list--nav .v-list-item {
    padding: 5px 15px;
}

.v-list-item--active:before,
.v-list-item--active:hover:before,
.v-list-item:focus:before {
    opacity: 1;
}

.theme--dark.v-list-item--active:before,
.theme--dark.v-list-item--active:hover:before,
.theme--dark.v-list-item:focus:before {
    opacity: 0;
}

.avatar-b-color {
    background-color: #fff !important;
}

.v-list-item--active {
    background-color: #59fee2 !important;
}
</style>
